import React, { useState, useRef } from 'react';
import { Chip, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/* ─── style constants ───────────────────────────────────────────── */
const CHIP_SX = {
  backgroundColor: '#e0e0e0',
  borderRadius   : '12px',
  padding        : '0 6px',
  height         : 20,
  fontSize       : '0.65rem',
  lineHeight     : 1,
  cursor         : 'pointer',
};

const DEL_ICON_SX = {
  fontSize : '8px',   // ↓ even smaller
  width    : 10,
  height   : 10,
  margin   : 0,
  padding  : 0,
};

/* ─── component ─────────────────────────────────────────────────── */
const ChipComponent = ({
  fieldUfi,
  label,
  onDoubleClick,
  onBlur,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [content , setContent ]   = useState(`{{${fieldUfi}}}`);
  const wrapperRef = useRef(null);

  const startEdit = () => { setIsEditing(true);  onDoubleClick?.(); };
  const stopEdit  = () => { setIsEditing(false); onBlur?.();        };
  const onChange  = e =>   setContent(e.currentTarget.textContent);

  const handleDelete = (e) => {
    e.stopPropagation();
    wrapperRef.current?.closest('[data-ufi]')?.remove();
  };

  return (
    <Box
      ref={wrapperRef}
      sx={{ display:'inline-block', position:'relative' }}
      onDoubleClick={startEdit}
    >
      {isEditing ? (
        <Box
          contentEditable
          suppressContentEditableWarning
          onInput={onChange}
          onBlur={stopEdit}
          sx={{
            display:'inline-block',
            px:0.5,
            border:'1px solid #ccc',
            borderRadius:1,
            backgroundColor:'#fff',
            fontSize:'0.65rem',
            lineHeight:1,
          }}
        >
          {content}
        </Box>
      ) : (
        <Chip
          size="small"
          label={label}
          onDelete={handleDelete}
          deleteIcon={<CloseIcon sx={DEL_ICON_SX} />}
          sx={CHIP_SX}
        />
      )}
    </Box>
  );
};

export default ChipComponent;
